// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm_box[data-v-73098b69] {\n  width: 828px !important;\n}\n.el-col[data-v-73098b69] {\n  margin-bottom: 12px !important;\n}\n.el-col-4[data-v-73098b69] {\n  width: 20%;\n}\n.el-button[data-v-73098b69] {\n  border-radius: 0px !important;\n}\n.searchBtn[data-v-73098b69] {\n  background-color: #337AFF;\n  color: #fff;\n}\n.searchBtn[data-v-73098b69]:hover {\n  background-color: #5c95ff;\n}", ""]);
// Exports
module.exports = exports;
